const faqs = [
  {
    q: '91黑料网是什么样的平台？',
    a: '91黑料网是一个专注于娱乐圈黑料与吃瓜爆料的资讯聚合平台。我们每日更新最新黑料事件、明星八卦、网红翻车等内容，为用户提供91黑料网在线观看服务，是广大吃瓜群众获取第一手娱乐资讯的首选网站。',
  },
  {
    q: '91黑料网的内容多久更新一次？',
    a: '91黑料网实行7×24小时全天候更新机制，编辑团队实时追踪全网热点黑料事件。无论在何时访问91黑料网站首页，都能看到最新的黑料吃瓜爆料内容，确保用户不错过任何重磅消息。',
  },
  {
    q: '如何找到91黑料网站首页最新入口？',
    a: '建议用户将91黑料网添加到浏览器收藏夹，或关注本站的社交媒体账号获取最新入口信息。本站域名稳定，用户可直接通过搜索引擎搜索"91黑料网"或"91黑料网站首页"找到我们。',
  },
  {
    q: '91黑料网的内容来源是否可靠？',
    a: '91黑料网的内容来源于公开网络信息与用户投稿，我们会对信息进行初步核实后再发布。但由于黑料事件的特殊性，部分内容可能存在主观判断，建议用户理性看待，本站内容仅供娱乐参考。',
  },
  {
    q: '可以在91黑料网上投稿爆料吗？',
    a: '可以的！91黑料网欢迎用户投稿爆料。您可以通过本站的联系我们板块提交您的爆料线索，编辑团队会在审核后择优发布，优质爆料内容将获得优先推荐展示。',
  },
  {
    q: '91黑料网支持手机端访问吗？',
    a: '当然支持！91黑料网已全面适配移动端设备，用户可通过手机浏览器直接访问，体验流畅的黑料浏览。同时我们也提供移动端快捷入口，方便用户随时随地吃瓜追料。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            关于91黑料网，你可能想了解的都在这里
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-label font-bold mt-0.5">
                    Q
                  </span>
                  <span className="font-heading text-base md:text-lg font-bold text-foreground-900">
                    {faq.q}
                  </span>
                </h3>
                <div className="mt-3 pl-9">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}